'use client';

import classes from "./loading.module.css"
import { useMobileApp } from "@/providers/mobile-app-context";
import Skeleton from "@/components/common/skeleton/skeleton";

export default function Loading({ stateMessage }) {
    const { isNativeApp } = useMobileApp();

    if (isNativeApp) {
        return (
            <div className={`${classes["loading-container"]}`}>
                <div className={`${classes["skeleton-stack"]}`}>
                    {[0, 1, 2].map(i => (
                        <div key={i} className={`${classes["skeleton-row"]}`}>
                            <Skeleton className={`${classes["skeleton-avatar"]}`} radius={12} />
                            <div className={`${classes["skeleton-lines"]}`}>
                                <Skeleton height={14} style={{ width: "70%" }} />
                                <Skeleton height={12} style={{ width: "40%" }} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className={`${classes["loading-container"]}`}>
            <div className="spinner-border align-middle d-flex justify-content-center" role="status">
                <span className="visually-hidden">Betöltés...</span>
            </div>
            <p className="color-gray-500 margin-3 font-medium">{stateMessage || ""}</p>
        </div>
    )
}